import initVODPlayer from './vod-player'

initVODPlayer({ selector: '#stv-vod-player' })
